import React from "react";

export default function ContactButton({ phone }: any) {
    const contactNumber = phone.replaceAll(" ", "").replaceAll("+", "");
    return (
        <a
            href={`tel:${contactNumber}`}
            className="phone-num group flex items-center text-white text-font-22 duration-300"
        >
            {phone}
        </a>
    );
}
